import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, object=auth
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    const token = localStorage.getItem("cc_token");
    if (!token) { setUser(false); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch (err) {
      console.error("Auth load failed", err);
      localStorage.removeItem("cc_token");
      setUser(false);
    }
    setReady(true);
  }, []);

  useEffect(() => { load(); }, [load]);

  const afterAuth = (data) => {
    if (data.access_token) localStorage.setItem("cc_token", data.access_token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    afterAuth(data);
    return data.user;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    afterAuth(data);
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.error("Logout request failed", err); }
    localStorage.removeItem("cc_token");
    setUser(false);
  };
  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data.user);
    return data.user;
  };

  const value = useMemo(() => ({ user, ready, login, register, logout, refreshUser, setUser }), [user, ready]);

  return (
    <AuthCtx.Provider value={value}>
      {children}
    </AuthCtx.Provider>
  );
}
